import React, { useEffect, useState } from "react";
import "./particularproduct.css";
import { FaStar } from "react-icons/fa";
import { MdAddShoppingCart } from "react-icons/md";
import { BiLike, BiDislike } from "react-icons/bi";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/slices/cartSlice";
import { addtocart } from "../../apis/Cart";
import axios from "axios";
import { toast } from "react-toastify";

function ParticularProduct({ bag, fetchbag, updateQuantity }) {
  const [loadingProductId, setLoadingProductId] = useState(null);

  const { productid, id } = useParams();
  const { state } = useLocation();
  const productId = decodeURIComponent(productid);
  const product = state?.product;

  const dispatch = useDispatch();

  const baseURL = `${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/products/`;
  const images = (product?.prod_img || "").split(",").map((img) => img.trim());
  const [selectedImage, setSelectedImage] = useState(images[0]);

  const getUserData = () => {
    try {
      return JSON.parse(localStorage.getItem("userData")) || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const [userData, setUserData] = useState(getUserData);

  const handleImageClick = (img) => {
    setSelectedImage(img);
  };

  const scrollLeft = () => {
    const container = document.querySelector(".main1122");
    const scrollAmount = container.offsetWidth;
    container.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    const container = document.querySelector(".main1122");
    const scrollAmount = container.offsetWidth;
    container.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  const [review, setreview] = useState([]);
  const [SimilarProducts, setSimilarProducts] = useState([]);

  const fetchreview = async () => {
    const formData = new FormData();
    formData.append("type", "customer");
    formData.append("prod_id", product?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/review_show.php`,
        formData
      );
      const rawData = res.data?.data;
      const data = Array.isArray(rawData) ? rawData : [];
      setreview([...data]);

      const breakdown = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      let total = 0;

      data.forEach((item) => {
        const rating = parseInt(item.rating);
        if (breakdown[rating] !== undefined) {
          breakdown[rating]++;
          total += rating;
        }
      });

      const totalRatings = data.length;
      const averageRating =
        totalRatings > 0 ? (total / totalRatings).toFixed(1) : 0;

      setRatingsSummary({
        totalRatings,
        totalReviews: data.length,
        averageRating,
        ratingsBreakdown: breakdown,
      });
    } catch (err) {
      console.error("Error fetching wishlist", err);
      setreview([]);
    }
  };

  const fetchsimilarproducts = async () => {
    const formData = new FormData();
    formData.append("category", product?.category);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/category_filter.php`,
        formData
      );

      if (res.data) {
        const similarData = res.data?.data || [];
        setSimilarProducts(similarData);
      } else {
        setSimilarProducts([]);
      }
    } catch (err) {
      console.error("Error fetching similar products", err);
      setSimilarProducts([]);
    }
  };

  const [ratingsSummary, setRatingsSummary] = useState({
    totalRatings: 0,
    totalReviews: 0,
    averageRating: 0,
    ratingsBreakdown: {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
    },
  });

  const getPercentage = (star) => {
    const total = ratingsSummary.totalRatings || 1;
    return ((ratingsSummary.ratingsBreakdown[star] / total) * 100).toFixed(1);
  };

  // ==========================================================================================

  const sizes = product.prod_size?.split(",").map((s) => s.trim()) || [];
  const prices = product.prod_price?.split(",").map((p) => p.trim()) || [];
  const discountedAmounts =
    product.discounted_amount?.split(",").map((d) => d.trim()) || [];
  const discounts =
    product.prod_discount?.split(",").map((d) => d.trim()) || [];
  const stocks = product.stock?.split(",").map((s) => s.trim()) || [];

  // Selected size index state
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);

  useEffect(() => {
    if (product?.prod_details?.length) {
      const firstItem = product.prod_details[0];

      setSelectedIndex(0);
      setSelectedSize(firstItem.prod_size);
      setSelectedPrice(
        firstItem.discounted_amount ?? firstItem.prod_price
      );
    }
  }, [product]);

  // Handle size selection
  const handleSizeSelect = (idx) => {
    const selectedItem = product?.prod_details?.[idx];

    setSelectedIndex(idx);
    setSelectedSize(selectedItem?.prod_size);

    const hasDiscount =
      selectedItem?.discounted_amount &&
      selectedItem?.discounted_amount !== 0;

    const finalPrice = hasDiscount
      ? selectedItem?.discounted_amount
      : selectedItem?.prod_price;

    setSelectedPrice(finalPrice);
  };


  useEffect(() => {
    fetchreview();
    fetchsimilarproducts();
  }, []);
  // ==========================================================================================

  if (!product) {
    return <div>Product not found or page reloaded.</div>;
  }

  const handleAddToCart = async (product, type, price, size) => {
    if (!size) {
      toast.error("Please select a size before adding to cart.");
      return;
    }

    if (loadingProductId === product.id) return;

    setLoadingProductId(product.id);

    try {
      await addtocart(product, type, fetchbag, price, size);
      dispatch(addToCart(product));
    } catch (error) {
      console.error("Failed to add to cart:", error);
    } finally {
      setLoadingProductId(null);
    }
  };

  // const [selectedIndex, setSelectedIndex] = useState(null); // Index of selected size

  return (
    <>
      <div className="outer-prod-div">
        <div className="image-outer">
          <div className="prod-image">
            {images.map((img, index) => (
              <img
                key={index}
                src={`${baseURL}${img}`}
                alt="thumbnail"
                className="small-i11"
                onClick={() => handleImageClick(img)}
              />
            ))}
          </div>
          <div className="main123">
            <div className="main-image1">
              <img
                src={`${baseURL}${selectedImage}`}
                alt="main"
                className="main-i11"
              />
            </div>
          </div>
        </div>

        <div className="prod-details">
          <h2>{product.prod_name}</h2>
          {ratingsSummary.totalReviews > 0 && (
            <div className="prod-details11">
              <p>
                <span
                  className="rating-status"
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    display: "inline-flex",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {ratingsSummary.averageRating}{" "}
                  <FaStar style={{ marginLeft: "4px" }} />
                </span>
              </p>
              <p className="rate-details">
                {Number(ratingsSummary.totalRatings).toLocaleString()} Ratings &{" "}
                {Number(ratingsSummary.totalReviews).toLocaleString()} Reviews
              </p>
            </div>
          )}

          {userData?.islogin === true && (
            <div className="prod-details111">
              <span className="price-current">
                ₹
                {product?.prod_details?.[selectedIndex]?.discounted_amount ??
                  product?.prod_details?.[selectedIndex]?.prod_price}
              </span>

              {product?.prod_details?.[selectedIndex]?.discounted_amount && (
                <>
                  <span className="price-original">
                    ₹{product?.prod_details?.[selectedIndex]?.prod_price}
                  </span>
                  <span className="price-discount">
                    {product?.prod_details?.[selectedIndex]?.prod_discount}% off
                  </span>
                </>
              )}
            </div>
          )}

          <div className="size-select">
            <label className="la1">Size:</label>
            {product?.prod_details?.map((item, idx) => (
              <button
                key={item.prod_size}
                className={`size-btn ${selectedIndex === idx ? "active" : ""}`}
                onClick={() => handleSizeSelect(idx)}
              >
                {item.prod_size}
              </button>
            ))}
          </div>


          {/* <div className="stock-indicator">
             Stock: {stocks[selectedIndex] || product.stock}
           </div> */}
          {userData?.islogin === true && (
            Array.isArray(bag) &&
              bag.some(
                (item) =>
                  String(item.product_id) === String(product?.id) &&
                  item.prod_size === selectedSize
              ) ? (
              bag
                .filter(
                  (item) =>
                    String(item.product_id) === String(product?.id) &&
                    item.prod_size === selectedSize
                )
                .map((item) => (
                  <div className="quantity-controls" key={item.id}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(item.id, -1, "cart");
                      }}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(item.id, 1, "cart");
                      }}
                    >
                      +
                    </button>
                  </div>
                ))
            ) : stocks[selectedIndex] === "0" ? (
              <div className="stock-indicator">
                <span style={{ color: "red" }}>Currently Unavaiable</span>
              </div>
            ) : (
              <button
                className="bookmarkBtn"
                // disabled={
                //   !selectedSize ||
                //   stocks[sizes.indexOf(selectedSize)] === "0" ||
                //   !stocks[sizes.indexOf(selectedSize)]
                // }
                onClick={() => {
                  console.log("Adding to cart:", {
                    id: product.id,
                    price: selectedPrice,
                    size: selectedSize,
                  });
                  handleAddToCart(
                    product.id,
                    "cart",
                    selectedPrice,
                    selectedSize
                  );
                }}
              >
                <span className="IconContainer">
                  <MdAddShoppingCart className="btn-icon" />
                </span>
                <p className="text">
                  {loadingProductId === product.id ? "Adding..." : "Add to Cart"}
                </p>
              </button>
            )
          )}

          <div className="delivery-det">
            <p className="secure-deli">{product.delivery_time}</p>
          </div>

          {/* Color selection - only if you have colors data */}
          {/* For now, you can ignore or add similar logic if color data exists */}

          {/* <div className="available-offer12">
            <ul className="offer-list">
              <p className="he1">Available Offers</p>
              {[
                {
                  title: "Bank Offer",
                  detail:
                    "5% cashback on Flipkart Axis Bank Credit Card up to ₹4,000 per statement quarter",
                },
                {
                  title: "Bank Offer",
                  detail:
                    "5% cashback on Axis Bank Flipkart Debit Card up to ₹750",
                },
                {
                  title: "Bank Offer",
                  detail:
                    "10% off up to ₹1500 on Axis Bank Credit Card EMI Txn. Min Txn Value ₹7500",
                },
                {
                  title: "Special Price",
                  detail:
                    "Get extra 34% off (price inclusive of cashback/coupon)",
                },
              ].map((offer, index) => (
                <li className="offer-item" key={index}>
                  <span className="offer-icon">
                    <FaTag />
                  </span>
                  <span className="offer-text">
                    <strong>{offer.title}</strong> {offer.detail}{" "}
                    <a href="/protect-promise-details">T&C</a>
                  </span>
                </li>
              ))}
            </ul>
          </div> */}
          <table className="delivery-table">
            <tbody>
              <tr>
                <td>
                  <label className="la1">Description</label>
                </td>
                <td>
                  <p className="desc">{product.prod_desc}</p>
                </td>
              </tr>

              <tr>
                <td>
                  <label className="la1">Highlights</label>
                </td>
                <td>
                  <ul className="highlight-list">
                    {product.features
                      .split(",")
                      .map((f) => f.trim())
                      .filter(Boolean)
                      .map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                  </ul>
                </td>
              </tr>

              <tr>
                <td>
                  <label className="la1">Services</label>
                </td>
                <td>
                  <ul className="highlight-list">
                    {product.payment
                      .split(",")
                      .map((f) => f.trim())
                      .filter(Boolean)
                      .map((service, idx) => (
                        <li key={idx}>{service}</li>
                      ))}

                    {/* Add return policy if available */}
                    {product.return_policy && (
                      <li>Returns accepted within {product.return_policy}</li>
                    )}
                  </ul>
                </td>
              </tr>

              <tr>
                <td>
                  <label className="la1">Seller</label>
                </td>
                <td>
                  <ul className="highlight-list">
                    <li>GST invoice available</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="rating-review">
            {ratingsSummary.totalReviews > 0 && (
              <div className="rating-review12">
                <div className="review12">
                  <p className="rat12">Rating & Reviews</p>
                  <p className="ratings-star12">
                    {ratingsSummary.averageRating} ★
                  </p>
                  <p className="rat13">
                    {ratingsSummary.totalRatings.toLocaleString()} Ratings &{" "}
                    <br />
                    {ratingsSummary.totalReviews.toLocaleString()} Reviews
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="review13">
                    {[5, 4, 3, 2, 1].map((star) => (
                      <div className="rating-row" key={star}>
                        <span className="star12">{star} ★</span>
                        <div className="bar-container">
                          <div
                            className="bar-fill"
                            style={{ width: `${getPercentage(star)}%` }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="line"></div>
            <h2>Customer Reviews</h2>
            {review.length > 0 ? (
              review.map((review, index) => (
                <div key={index} className="review-cust12">
                  {/* Rating Display */}
                  <p>
                    <span
                      className="rating-status"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-flex",
                        alignItems: "center",
                        fontWeight: "bold",
                        fontSize: "10px",
                      }}
                    >
                      {review.rating} <FaStar style={{ marginLeft: "4px" }} />
                    </span>
                  </p>

                  {/* Review Images */}
                  <div className="prod-image12">
                    {review.review_images &&
                      review.review_images
                        .split(",")
                        .map((imgName, idx) => (
                          <img
                            key={idx}
                            src={`${process.env.REACT_APP_BASEURL
                              }/apis/customer/uploads/reviews/${imgName.trim()}`}
                            alt="Review"
                            className="small-i111"
                          />
                        ))}
                  </div>

                  {/* Review Comment */}
                  <p className="cust14">{review.commands}</p>

                  {/* Customer Info */}
                  <p className="customer11">{review.customer_name}</p>

                  {/* Like/Dislike Icons */}
                  <div className="rev-like12">
                    <p>
                      <span>
                        <BiLike /> <BiDislike />
                      </span>
                    </p>
                  </div>

                  <div className="line"></div>
                </div>
              ))
            ) : (
              <p>No reviews found.</p>
            )}
          </div>
        </div>
      </div>

      {Array.isArray(SimilarProducts) && SimilarProducts.length > 1 && (
        <div className="products1122">
          <h2 className="pro1122">Similar Products</h2>
          <div className="scroll-container1122">
            <button
              className="scroll-arrow left-arrow1122"
              onClick={scrollLeft}
            >
              ‹
            </button>

            <div className="main1122">
              {SimilarProducts.filter(
                (p) => p.product_id !== product.product_id
              ).map((similarProduct, index) => {
                const firstImage = similarProduct.prod_img
                  ?.split(",")[0]
                  ?.trim();

                return (
                  <div className="main-image1122" key={index}>
                    <img
                      src={`${process.env.REACT_APP_BASEURL}/apis/vendor/uploads/products/${firstImage}`}
                      alt={similarProduct.prod_name}
                      className="main-i1122"
                    />
                    <p className="product-text1122">
                      {similarProduct.prod_name} <br />₹
                      {similarProduct.discounted_amount.split(",")[0]}
                    </p>
                  </div>
                );
              })}
            </div>

            <button
              className="scroll-arrow right-arrow1122"
              onClick={scrollRight}
            >
              ›
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ParticularProduct;
